import { render, staticRenderFns } from "./ChangeStatusDemo.vue?vue&type=template&id=500e055c"
import script from "./ChangeStatusDemo.vue?vue&type=script&lang=js"
export * from "./ChangeStatusDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports